import { useEffect, useState } from "react";
import api from "../../services/api";
import { toast } from "../../hooks/use-toast";
import { useTranslation } from "react-i18next";

const baseFields = [
  "hero_title",
  "hero_subtitle",
  "story_title",
  "story_paragraph_1",
  "story_paragraph_2",
  "story_paragraph_3",
  "mission_text",
  "vision_text",
  "value1_title",
  "value1_description",
  "value2_title",
  "value2_description",
  "value3_title",
  "value3_description",
  "emphasis_title",
  "emphasis_text",
];

// const initialState = editableFields.reduce((acc, field) => {
//   acc[field] = "";
//   return acc;
// }, {});

// Generate bilingual fields
const generateInitialState = () => {
  const state = {};
  baseFields.forEach((field) => {
    state[`${field}_en`] = "";
    state[`${field}_ar`] = "";
  });
  return state;
};

const AdminAboutUs = () => {
  const { t } = useTranslation();
 const [formData, setFormData] = useState(generateInitialState());

  const loadAbout = async () => {
    try {
      const res = await api.get("/about-us");

      if (res.data) {
        setFormData((prev) => ({
          ...prev,
          ...res.data,
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadAbout();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await api.post("/about-us/update", formData);

      toast({
        title: t("admin.about.success"),
      });
    } catch (err) {
      toast({
        title: t("admin.about.errorTitle"),
        description: t("admin.about.errorDescription"),
        variant: "destructive",
      });
    }
  };

  return (
    <div className="bg-card p-8 rounded-2xl shadow-soft max-w-4xl mx-auto">
      <h2 className="text-2xl font-serif font-bold mb-6">
         {t("admin.about.title")}
      </h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        {baseFields.map((field) => (
          <div key={field} className="space-y-4 border-b pb-6">
            <label className="block text-sm font-semibold">
              {t(`admin.about.fields.${field}`)}
            </label>

            {/* English */}
            <div>
              <label className="text-xs text-muted-foreground">
                {t("admin.about.english")}
              </label>
              <textarea
                rows={
                  field.includes("paragraph") || field.includes("text")
                    ? 4
                    : 2
                }
                value={formData[`${field}_en`]}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [`${field}_en`]: e.target.value,
                  }))
                }
                className="w-full mt-1 px-4 py-3 rounded-xl bg-background border border-border focus:border-primary outline-none"
              />
            </div>

            {/* Arabic */}
            <div>
              <label className="text-xs text-muted-foreground">
                {t("admin.about.arabic")}
              </label>
              <textarea
                dir="rtl"
                rows={
                  field.includes("paragraph") || field.includes("text")
                    ? 4
                    : 2
                }
                value={formData[`${field}_ar`]}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [`${field}_ar`]: e.target.value,
                  }))
                }
                className="w-full mt-1 px-4 py-3 rounded-xl bg-background border border-border focus:border-primary outline-none text-right"
              />
            </div>
          </div>
        ))}

        <button type="submit" className="btn-hero w-full">
         {t("admin.about.updateButton")}
        </button>
      </form>
    </div>
  );
};

export default AdminAboutUs;